import type { Plan } from "@/react/types/Plan";
import { PlanFeature } from "../PlanSelector/PlanFeature";
import {
  isValidPublicPlanTier,
  tierHighlights,
} from "../PlanSelector/tierHighlights";

interface FeaturesListProps {
  plan: Plan;
  shouldHighlightFeatures: boolean;
}

export const FeaturesList = ({
  plan,
  shouldHighlightFeatures,
}: FeaturesListProps) => {
  if (!isValidPublicPlanTier(plan.tier)) return null;

  const planTier = plan.tier;
  const features = tierHighlights[planTier];
  return (
    <>
      {features.map((feature: string) => (
        <PlanFeature
          key={feature}
          feature={feature}
          isHighlighted={shouldHighlightFeatures}
        />
      ))}
    </>
  );
};
